import MediaSettingsView from 'common/components/MediaSettings';
import { MediaSettings } from 'common/slice/mediaSettingSlice';
import { AudioSettings } from 'common/slice/audioSettingSlice';
import { useAppSelector } from 'app/hooks';
import StreamVideoContainer from 'common/components/StreamVideoContainer';
import TileStatus from './TileStatus';
import { SessionStatus } from 'globals/enums';

const Tile = ({
  sessionStatus,
  attendeeId,
  participant,
  isApprovalPending,
  availableSettings,
  isReconnecting = false,
  criticalAlertCount = 0,
}) => {
  const mediaSettings: MediaSettings = useAppSelector((state) => state.mediaSettings);
  const audioSettings: AudioSettings = useAppSelector((state) => state.audioSettings);

  const participantMediaSetting = mediaSettings.mediaSettings.find(
    (a) => a.attendeeId === attendeeId,
  );

  const currentFeed = !participantMediaSetting
    ? mediaSettings.currentFeed
    : participantMediaSetting.currentFeed;

  const currentAutoRotateFeed = mediaSettings.currentAutoRotateFeed;

  const participantAudioSetting = audioSettings.audioSettings.find(
    (a) => a.attendeeId === attendeeId,
  );

  const currentAudioStatus = !participantAudioSetting
    ? audioSettings.isMuted
    : participantAudioSetting.isMuted;

  return (
    <>
      {criticalAlertCount > 0 && (
        <span
          className="absolute top-2 right-2 z-10 flex items-center justify-center rounded-full bg-red-600 px-2 py-0.5 text-xs font-semibold text-white shadow"
          aria-label={`Critical alerts: ${criticalAlertCount}`}
          data-testid={`critical-alert-badge-${attendeeId}`}
        >
          {criticalAlertCount}
        </span>
      )}
      {(isApprovalPending ||
        sessionStatus === SessionStatus.Completed ||
        sessionStatus === SessionStatus.Terminated ||
        isReconnecting ||
        !participant) && <TileStatus type={sessionStatus} isApprovalPending={isApprovalPending} isReconnecting={isReconnecting} />}
      {participant &&
        sessionStatus !== SessionStatus.Completed &&
        sessionStatus !== SessionStatus.Terminated && (
          <StreamVideoContainer
            attendeeId={attendeeId}
            participant={participant}
            currentAudioStatus={currentAudioStatus}
            currentAutoFeed={currentFeed === 'auto-rotate' ? currentAutoRotateFeed : currentFeed}
            isApprovalPending={isApprovalPending}
            isReconnecting={isReconnecting}
          />
        )}
      {participant && (
        <MediaSettingsView
          attendeeId={attendeeId}
          currentFeed={currentFeed}
          availableSettings={availableSettings}
        />
      )}
    </>
  );
};

export default Tile;
